
export class AlertMicrosoftTeamsHelper {
  static readonly MICROSOFT_TEAMS_CHAR_LIMIT = 10000;
}